














































































import { Component, Prop, Mixins, Watch } from 'vue-property-decorator';
import AppTabs from '@/layouts/AppTabs.vue';
import AppNavigationDrawer from '@/layouts/AppNavigationDrawer.vue';
import Footer from '@/layouts/Footer.vue';
import ScrollEventMixin from '@/mixins/ScrollEvent.mixin';

@Component({
  components: {
    AppTabs,
    AppNavigationDrawer,
    Footer,
  }
})
export default class AppBar extends Mixins(ScrollEventMixin) {

  /**
   * The height of the header by default.
   */
  @Prop({ type: String, default: '500px' }) private shrinkHeight!: string;
  /**
   * The scroll threshold of the shrink.
   */
  @Prop({ type: Number, default: 400 }) private scrollThreshold!: number;

  @Prop({ type: Boolean, default: false }) private shrink!: boolean;

  /**
   * Is the shrink effect completed.
   */
  private shrinkCompleted = false;

  /**
   * The shrink percentage. 1 means the app bar has its maximum height, and 0 its minimum.
   */
  private shrinkPercentage = 0;

  /**
   * Is the app bar visible.
   */
  private isVisible = true;

  /**
   * Is the drawer displayed.
   */
  private drawer = false;

  /**
   * Vue app title.
   */
  get title(): string {
    return process.env.VUE_APP_TITLE;
  }

  /**
   * Dynamic app bar props depending on properties.
   */
  get dynamicAppBarProps(): { [key: string]: boolean|number|string } {
    const props: { [key: string]: boolean|number|string } = {
      'hide-on-scroll': true,
      'scroll-threshold': 0,
    };
    if (this.shrink) {
      props['fade-img-on-scroll'] = true;
      props['src'] = require('../assets/home-bg.jpg');
      if (!this.shrinkCompleted) {
        props['hide-on-scroll'] = false;
        props['scroll-threshold'] = this.scrollThreshold;
        props['height'] = this.shrinkHeight;
      }
    }
    return props;
  }

  /**
   * The welcome text style.
   */
  get welcomeStyle() {
    // The percentage threshold when the welcome message is completely transparent
    const threshold = 0.4;
    const opacity = (this.shrinkPercentage - threshold) / (1 - threshold);
    return {
      'opacity': opacity > 0 ? opacity : 0,
    };
  }

  mounted() {
    this.updateAppBar();
  }

  protected onScrollDebounced() {
    this.updateAppBar();
  }

  /**
   * Update app bar data (height & shrink state).
   */
  @Watch('shrink')
  @Watch('$route')
  private updateAppBar() {
    this.shrinkCompleted = !this.shrink || window.scrollY >= this.scrollThreshold;
    this.shrinkPercentage = this.shrinkCompleted ? 0 :
      (this.scrollThreshold - window.scrollY) / this.scrollThreshold;
    if (!this.shrinkCompleted && !this.isVisible) {
      this.isVisible = true;
    }
  }
  
}
